import { cva, type VariantProps } from "class-variance-authority"

export const statusVariants = cva(
  "inline-flex items-center justify-center px-2 py-0.5 font-medium rounded-full border focus:outline-none text-xs",
  {
    variants: {
      variant: {
        success: "bg-status-success-bg text-status-success-text border-status-success-border",
        error: "bg-status-error-bg text-status-error-text border-status-error-border",
        warning: "bg-status-warning-bg text-status-warning-text border-status-warning-border",
        info: "bg-status-info-bg text-status-info-text border-status-info-border",
        neutral: "bg-muted text-muted-foreground border-border",
        pending: "bg-status-pending-bg text-status-pending-text border-status-pending-border",
        indigo: "bg-indigo-50 text-indigo-700 border-indigo-200",
      },
      size: {
        sm: "text-xs px-1.5 py-0.5",
        default: "text-xs px-2 py-0.5",
        lg: "text-sm px-2.5 py-1",
      },
    },
    defaultVariants: {
      variant: "neutral",
      size: "default",
    },
  },
)

export interface StatusBadgeConfig {
  text: string
  variant: VariantProps<typeof statusVariants>["variant"]
  tooltip: string
  actionable?: boolean
}

export interface StatusBadgeProps extends VariantProps<typeof statusVariants> {
  status: string
  statusConfig: Record<string, StatusBadgeConfig>
  defaultStatus?: string
  onClick?: (status: string) => void
  "data-testid"?: string
}
